export default __webpack_public_path__ + "static/media/chart.07b85ba6.svg";